import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { urlEquipmentControl, urlEquipmentService, urlDispatchService } from '@src/endpoints'
import { getUriParams } from '@utils'

// Set Container Free Time
export const setContainerFreeTime = createAsyncThunk(
  'equipmentControl/SetContainerFreeTime',
  async (freeTimeModel, { rejectWithValue }) => {
    try {
      const url = `${urlEquipmentControl}/SetContainerFreeTime`
      console.log('SetContainerFreeTime URL:', url)
      console.log('urlEquipmentControl:', urlEquipmentControl)
      const response = await axios.post(url, freeTimeModel)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

// Send Container Dispatch Amount (for Send To Dispatch)
export const sendContainerDispatchAmount = createAsyncThunk(
  'equipmentControl/DispatchContainerAmount',
  async (data) => {
    try {
      const response = await axios.post(`${urlEquipmentControl}/DispatchContainerAmount`, data)
      return response.data
    } catch (error) {
      console.error('Error dispatching container amount:', error)
      throw error
    }
  }
)

// Create Movement Reference (for Add Empty Release)
export const createMovementReference = createAsyncThunk(
  'equipmentControl/CreateMovementReference',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${urlEquipmentControl}/CreateMovementReference`, data)
      return response.data
    } catch (error) {
      console.error('Error creating movement reference:', error)
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getAllOceanBookingsWithInboundEquipment = createAsyncThunk(
  'equipmentControl/GetAllOceanBookingsWithInboundEquipment', 
  async data => {

  const { params, filterForm } = data
  const uri = getUriParams(params)

  const requestBody = {
    containerSizeCode: filterForm.containerSizeCode,
    shippingLineCode: filterForm.shippingLineCode,
    bookingNumber: filterForm.bookingNumber,
    customer: filterForm.customer,
    forwarderReferenceNumber: filterForm.forwarderReferenceNumber,
    shouldHold: filterForm.shouldHold,
    containerStatus: filterForm.containerStatus
  }

  const response = await axios.post(`${urlEquipmentControl}/GetAllOceanBookingsWithInboundEquipment?${uri}`, requestBody)
  
  return {
    params,
    data: response.data.data || [],
    totalPages: response.data.totalCount || 0,
    loaded: true,
    filterForm
  }
})

export const getAllBookings = createAsyncThunk('equipmentControl/GetAllBookings', async data => {
  const { params, filterForm } = data
  const uri = getUriParams(params)

  const requestBody = {
    containerSizeCode: filterForm.containerSizeCode,
    shippingLineCode: filterForm.shippingLineCode,
    bookingNumber: filterForm.bookingNumber,
    customer: filterForm.customer,
    forwarderReferenceNumber: filterForm.forwarderReferenceNumber,
    shouldHold: filterForm.shouldHold,
    containerStatus: filterForm.containerStatus
  }

  const response = await axios.post(`${urlEquipmentControl}/GetAllBookings?${uri}`, requestBody)
  
  return {
    params,
    data: response.data.data || [],
    totalPages: response.data.totalCount || 0,
    loaded: true,
    filterForm
  }
})

export const getContainerNeedByLocationShippingLineAndSize = createAsyncThunk(
  'equipmentControl/GetContainerNeedByLocationShippingLineAndSize', 
  async (params) => {

    const { shippingLineCode, containerSizeCode, location, clearPrevious = false } = params
    
    try {
      const response = await axios.post(`${urlEquipmentControl}/GetContainerNeedByLocationShippingLineAndSize`, {
        Line: shippingLineCode,
        Size: containerSizeCode,
        Location: location
      })

      return {
        containerNeedItem: response.data.data,
        clearPrevious
      }

    } catch (error) {
      console.error('Error fetching container need:', error)
      throw error
    }
  }
)

export const getEquipmentByMovementType = createAsyncThunk(
  'equipmentControl/GetEquipmentByMovementType', 
  async (data) => {

    const { params, filter } = data
    const uri = getUriParams(params)
    
    const requestBody = {
      movementType: filter.movementType || "",
      yardLocation: filter.terminal || "ALL",
      customerName: filter.customerName === "ALL" || filter.customerName === "" ? "" : filter.customerName || "",
      line: filter.line || "",
      referenceNumber: filter.referenceNumber || "",
      equipmentStatus: filter.equipmentStatus || "",
      commodityType: filter.commodityType || "",
      equipmentType: filter.equipmentType || "ALL",
      from: filter.from || null,
      to: filter.to || null,
      destination: filter.destination || "",
      origin: filter.origin || "",
      cargoType: filter.cargoType || "",
      commodity: filter.commodity || "",
      grade: filter.grade || "",
      lotNumber: filter.lotNumber || "",
      lastTracedLocation: filter.lastTracedLocation || "",
      servingYard: filter.servingYard || "",
      tracingStatus: filter.tracingStatus || "",
      equipmentSize: filter.equipmentSize || "",
      shipper: filter.shipper || ""
    }
    
    try {
      const response = await axios.post(`${urlEquipmentService}/GetEquipmentByMovementType?${uri}`, requestBody)
      
      return {
        params,
        data: response.data.data || [],
        totalPages: response.data.totalCount || 0,
        loaded: true,
        filter
      }
    } catch (error) {
      console.error('Error fetching equipment by movement type:', error)
      throw error
    }
  }
)

export const getAvailableEquipment = createAsyncThunk(
  'equipmentControl/GetAvailableEquipment', 
  async (data) => {

    const { params, filter } = data
    const uri = getUriParams(params)
    
    const requestBody = {
      EquipmentType: filter.EquipmentType || "CONTAINER",
      YardLocation: filter.YardLocation || "ALL",
      Line: filter.Line || "",
      EquipmentStatus: filter.EquipmentStatus || "",
      EquipmentSizes: filter.EquipmentSizes || [],
      CustomerName: filter.CustomerName || "",
      ReferenceNumber: filter.ReferenceNumber || "",
      EquipmentNumber: filter.EquipmentNumber || "",
      From: filter.From || null,
      To: filter.To || null,
      IsStorageRequired: filter.IsStorageRequired || false,
      Destination: filter.Destination || "",
      FreeTime: (filter.FreeTime !== undefined && filter.FreeTime !== null && filter.FreeTime !== '') ? Number(filter.FreeTime) : undefined
    }
    
    try {
      const response = await axios.post(`${urlEquipmentService}/GetAvailableEquipment?${uri}`, requestBody)
      
      return {
        params,
        data: response.data.data || [],
        totalPages: response.data.totalCount || 0,
        loaded: true,
        filter
      }
    } catch (error) {
      console.error('Error fetching available equipment:', error)
      throw error
    }
  }
)

export const getContainersInYard = createAsyncThunk(
  'equipmentControl/GetContainersInYard', 
  async (data) => {

    const { params, filter } = data
    const uri = getUriParams(params)
    
    const requestBody = {
      EquipmentType: filter.EquipmentType || "CONTAINER",
      YardLocation: filter.YardLocation || "ALL",
      Line: filter.Line || "",
      EquipmentStatus: filter.EquipmentStatus || "ALL",
      EquipmentSizes: filter.EquipmentSizes || [],
      CustomerName: filter.CustomerName || "",
      EquipmentNumber: filter.EquipmentNumber || "",
      ReferenceNumber: filter.ReferenceNumber || "",
      Destination: filter.Destination || "",
      CurrentAssignmentType: filter.CurrentAssignmentType || "",
      From: filter.From || null,
      To: filter.To || null,
      IsStorageRequired: filter.IsStorageRequired || false,
      FreeTime: (filter.FreeTime !== undefined && filter.FreeTime !== null && filter.FreeTime !== '') ? Number(filter.FreeTime) : undefined
    }
    
    try {
      const response = await axios.post(`${urlEquipmentControl}/GetContainersInYard?${uri}`, requestBody)
      
      return {
        params,
        data: response.data.data || [],
        totalPages: response.data.totalCount || 0,
        loaded: true,
        filter
      }
    } catch (error) {
      console.error('Error fetching containers in yard:', error)
      throw error
    }
  }
)

export const dispatchContainers = createAsyncThunk(
  'equipmentControl/DispatchContainers',
  async (dispatchList, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${urlEquipmentControl}/DispatchContainers`, dispatchList)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getPendingDispatchContainers = createAsyncThunk(
  'equipmentControl/GetPendingDispatchByContainers',
  async (containerNumbers, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${urlDispatchService}/GetPendingDispatchByContainers`, containerNumbers)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getStreetTurnRequests = createAsyncThunk(
  'equipmentControl/GetStreetTurnRequests',
  async (data) => {
    const { params, filter } = data
    const uri = getUriParams(params)

    const requestBody = {
      // equipmentNumber: filter.EquipmentNumber || '',
      shippingLine: filter.Line || '',
      equipmentSizeList: filter.EquipmentSizes || [],
      streetTurnConfirmed: filter.StreetTurnConfirmed || null
    }

    const response = await axios.post(`${urlEquipmentService}/GetAllStreetTurnRequest?${uri}`, requestBody)
    
    return {
      params,
      data: response.data.data || [],
      totalPages: response.data.totalCount || 0,
      filter
    }
  })

export const approveStreetTurnRequest = async (data) => {
  try {
    const response = await axios.post(`${urlEquipmentService}/ApproveStreetTurnRequest`, data)
    if (response.data.success) {
      return { success: true, message: response.data.messages?.[0] || 'Street turn approved successfully' }
    } else {
      return { success: false, message: response.data.errors?.[0] || 'Failed to approve street turn' }
    }
  } catch (error) {
    return { success: false, message: 'Internal server Error' }
  }
}

export const undoStreetTurnRequest = async (data) => {
  try {
    const response = await axios.post(`${urlEquipmentService}/UndoStreetTurnRequest`, data)
    if (response.data.success) {
      return { success: true, message: response.data.messages?.[0] || 'Street turn request undone successfully' }
    } else {
      return { success: false, message: response.data.errors?.[0] || 'Failed to undo street turn request' }
    }
  } catch (error) {
    return { success: false, message: 'Internal server Error' }
  }
}

export const updateStreetTurnDeadline = async (data) => {
  try {
    const response = await axios.post(`${urlEquipmentService}/UpdateDeadlineDateStreetTurnRequest`, data)
    if (response.data.success) {
      return { success: true, message: response.data.messages?.[0] || 'Deadline updated successfully' }
    } else {
      return { success: false, message: response.data.errors?.[0] || 'Failed to update deadline' }
    }
  } catch (error) {
    return { success: false, message: 'Internal server Error' }
  }
}

export const equipmentControlSlice = createSlice({
  name: 'equipmentControl',
  initialState: {
    loaded: false,
    data: [],
    terminal: {},
    customers: [],
    total: 1,
    params: {},
    filterForm: {
      EquipmentType: 'CONTAINER',
      YardLocation: 'ALL',
      Line: '',
      EquipmentStatus: '',
      EquipmentSizes: [],
      Status: '',
      CustomerName: '',
      ReferenceNumber: '',
      EquipmentNumber: '',
      From: '',
      To: '',
      IsStorageRequired: false,
      Origin: '',
      Destination: '',
      FreeTime: '',
      // Equipment Control List specific filters
      bookingNumber: '',
      customer: '',
      shippingLineCode: 'MSC',
      containerSizeCode: '20SD',
      forwarderReferenceNumber: '',
      shouldHold: null
    },
    selectedOceanBooking: null,
    loadedOceanBooking: false,
    containerNeed: [],
    containerNeedLoaded: false,
    lastFetchedTimestamp: null,
    // New state for equipment by movement type
    equipmentByMovementType: [],
    equipmentByMovementTypeLoaded: false,
    equipmentByMovementTypeParams: {},
    equipmentByMovementTypeTotal: 0,
    // New state for available equipment (containers in yard)
    availableEquipment: [],
    availableEquipmentLoaded: false,
    availableEquipmentParams: {},
    availableEquipmentTotal: 0,
    availableEquipmentFilter: {},
    // State for street turn requests list
    streetTurnRequest: {
      data: [],
      total: 0,
      params: {},
      filter: {},
      loaded: false
    },
    // New state for containers in yard
    containersInYard: [],
    containersInYardLoaded: false,
    containersInYardParams: {},
    containersInYardTotal: 0,
    containersInYardFilter: {
      EquipmentType: 'CONTAINER',
      YardLocation: 'ALL',
      Line: '',
      EquipmentStatus: 'ALL',
      EquipmentSizes: [],
      CustomerName: '',
      EquipmentNumber: '',
      ReferenceNumber: '',
      Destination: '',
      CurrentAssignmentType: '',
      From: null,
      To: null,
      IsStorageRequired: false
    }
  },
  reducers: {
    // Action to update filter form
    updateFilterForm: (state, action) => {
      state.filterForm = { ...state.filterForm, ...action.payload }
    },
    // Action to reset filter form
    resetFilterForm: (state) => {
      state.filterForm = {
        EquipmentType: 'CONTAINER',
        YardLocation: 'ALL',
        Line: '',
        EquipmentStatus: '',
        EquipmentSizes: [],
        Status: '',
        CustomerName: '',
        ReferenceNumber: '',
        EquipmentNumber: '',
        From: '',
        To: '',
        IsStorageRequired: false,
        Origin: '',
        Destination: '',
        FreeTime: '',
        // Equipment Control List specific filters
        bookingNumber: '',
        customer: '',
        shippingLineCode: 'MSC',
        containerSizeCode: '20SD',
        forwarderReferenceNumber: '',
        shouldHold: null
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAllOceanBookingsWithInboundEquipment.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.terminal = action.payload.terminal
        state.filterForm = action.payload.filterForm
      })
      .addCase(getAllOceanBookingsWithInboundEquipment.rejected, (state) => {
        state.loaded = true
        state.data = []
        state.params = {}
        state.total = 0
      })
      .addCase(getAllBookings.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.terminal = action.payload.terminal
        state.filterForm = action.payload.filterForm
      })
      .addCase(getAllBookings.rejected, (state) => {
        state.loaded = true
        state.data = []
        state.params = {}
        state.total = 0
      })      
      .addCase(getContainerNeedByLocationShippingLineAndSize.pending, (state, action) => {
        // If this is the first call with clearPrevious flag, clear the array
        if (action.meta.arg.clearPrevious) {
          state.containerNeed = []
        }
        state.containerNeedLoaded = false
      })

      .addCase(getContainerNeedByLocationShippingLineAndSize.fulfilled, (state, action) => {
        // Add the new item to the containerNeed array
        state.containerNeed.push(action.payload.containerNeedItem)
       
        // Store timestamp when first item is added or when clearing previous data
        if (state.containerNeed.length === 1 || action.payload.clearPrevious) {
          state.lastFetchedTimestamp = new Date().toISOString()
        }
        
        // After 3 calls are complete (all locations), mark as loaded
        // In a real app, you might want a more robust way to track this
        if (state.containerNeed.length >= 3) {
          state.containerNeedLoaded = true
        }
      })

      .addCase(getContainerNeedByLocationShippingLineAndSize.rejected, (state) => {
        // Even on error, allow the UI to recover
        state.containerNeedLoaded = true
      })
      .addCase(getEquipmentByMovementType.pending, (state) => {
        state.equipmentByMovementTypeLoaded = false
      })
      .addCase(getEquipmentByMovementType.fulfilled, (state, action) => {
        state.equipmentByMovementTypeLoaded = action.payload.loaded
        state.equipmentByMovementType = action.payload.data
        state.equipmentByMovementTypeParams = action.payload.params
        state.equipmentByMovementTypeTotal = action.payload.totalPages
      })
      .addCase(getEquipmentByMovementType.rejected, (state) => {
        state.equipmentByMovementTypeLoaded = true
        state.equipmentByMovementType = []
        state.equipmentByMovementTypeParams = {}
        state.equipmentByMovementTypeTotal = 0
      })
      .addCase(getAvailableEquipment.pending, (state) => {
        state.availableEquipmentLoaded = false
      })
      .addCase(getAvailableEquipment.fulfilled, (state, action) => {
        state.availableEquipmentLoaded = action.payload.loaded
        state.availableEquipment = action.payload.data
        state.availableEquipmentParams = action.payload.params
        state.availableEquipmentTotal = action.payload.totalPages
        state.availableEquipmentFilter = action.payload.filter
      })
      .addCase(getAvailableEquipment.rejected, (state) => {
        state.availableEquipmentLoaded = true
        state.availableEquipment = []
        state.availableEquipmentParams = {}
        state.availableEquipmentTotal = 0
        state.availableEquipmentFilter = {}
      })
      .addCase(getContainersInYard.pending, (state) => {
        state.containersInYardLoaded = false
      })
      .addCase(getContainersInYard.fulfilled, (state, action) => {
        state.containersInYardLoaded = true
        state.containersInYard = action.payload.data
        state.containersInYardParams = action.payload.params
        state.containersInYardTotal = action.payload.totalPages
        state.containersInYardFilter = action.payload.filter
      })
      .addCase(getContainersInYard.rejected, (state) => {
        state.containersInYardLoaded = true
        state.containersInYard = []
        state.containersInYardParams = {}
        state.containersInYardTotal = 0
        state.containersInYardFilter = {}
      })
      .addCase(getStreetTurnRequests.pending, (state) => {
        state.streetTurnRequest.loaded = false
      })
      .addCase(getStreetTurnRequests.fulfilled, (state, action) => {
        state.streetTurnRequest.loaded = true
        state.streetTurnRequest.data = action.payload.data
        state.streetTurnRequest.params = action.payload.params
        state.streetTurnRequest.total = action.payload.totalPages
        state.streetTurnRequest.filter = action.payload.filter
      })
      .addCase(getStreetTurnRequests.rejected, (state) => {
        state.streetTurnRequest.loaded = true
        state.streetTurnRequest.data = []
        state.streetTurnRequest.params = {}
        state.streetTurnRequest.total = 0
      })
      .addMatcher(action => action.type.endsWith('/fulfilled'), (state) => {
        state.loaded = true
      })
      .addMatcher(action => action.type.endsWith('/pending'), (state) => {
        state.loaded = false
      })
      .addMatcher(action => action.type.endsWith('/rejected'), (state) => {
        state.loaded = true
      })
  }
})

// Export actions
export const { updateFilterForm, resetFilterForm } = equipmentControlSlice.actions

// Assign Trucker (for Send to Dispatch)
export const assignTrucker = async (data) => {
  try {
    const response = await axios.post(`${urlEquipmentService}/AssignTruckingCompany`, data)
    return response.data
  } catch (error) {
    return { success: false, message: error.response?.data?.messages || 'Error assigning trucker' }
  }
}

export default equipmentControlSlice.reducer
